import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom"; 

function NavigateHome() {
  const navigate = useNavigate();
 
  const [token, setToken] = useState(localStorage.getItem("token"));
 
  // ✅ Check token on mount
  useEffect(() => {
    const storedToken = localStorage.getItem("token");

    if (!storedToken) {
      // No token → redirect to home
      navigate("/", { replace: true });
      return;
    }

    // Optionally: decode JWT to check expiry
    try {
      const payload = JSON.parse(atob(storedToken.split(".")[1]));
      const isExpired = payload.exp * 1000 < Date.now();
      if (isExpired) {
        localStorage.removeItem("token");
        navigate("/", { replace: true });
      }
    } catch (error) {
      // Invalid token
      localStorage.removeItem("token");
      navigate("/", { replace: true });
    }
  }, [navigate]);
  
 
  return (

    <>

  
    </>

  );
}

export default NavigateHome;
